<template>
  <van-field
    :disabled="disabled"
    :border="false"
    maxlength="13"
    type="tel"
    placeholder="请输入手机号码"
    v-model.trim="phoneNo"
    :formatter="formatPhoneNo">
  </van-field>
</template>

<script>
export default {
  name: 'field-format-phone',

  model: {
    value: 'value',
    input: 'input'
  },

  props: {
    value: String,
    disabled: Boolean
  },

  computed: {
    phoneNo: {
      get() {
        return this.formatPhoneNo(this.value)
      },
      set(val) {
        const rawPhone = this.getRawPhoneNo(val)
        this.$emit('input', rawPhone)
      }
    },
  },

  methods: {
    formatPhoneNo(formatedPhoneNo) {
      const rawPhoneNo = formatedPhoneNo.replace(/\s/g, '')

      return rawPhoneNo.length > 7
        ? rawPhoneNo.replace(/^(\d{3})(\d{4})(\d+)/, '$1 $2 $3')
        : rawPhoneNo.length > 3
          ? rawPhoneNo.replace(/^(\d{3})(\d+)/, '$1 $2')
          : rawPhoneNo
    },

    getRawPhoneNo(phoneNo) {
      return phoneNo.replace(/\s/g, '')
    },
  },
}
</script>
